// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0bdaf8fab400b6763829","351":"72ce3081913266d8c804","691":"319e7a62c4ae84abaf50"}[chunkId] + ".js";
};